import { createContext } from "react";

export type OverlayKind = "note" | "picture";
export type OverlaySizeKey = "S" | "M" | "L";

export interface PersistedOverlayItem {
  id: string;
  kind: OverlayKind;
  size: OverlaySizeKey;
  position: { x: number; y: number };
  noteText: string;
  pictureUrl: string | null;
  collapsed: boolean;
}

export type NotesAndPicturesContextValue = {
  items: PersistedOverlayItem[];
  addItem: (kind: OverlayKind) => void;
  removeItem: (id: string) => void;
  updateItem: (
    id: string,
    patch: Partial<Omit<PersistedOverlayItem, "id" | "kind">>,
  ) => void;
  importItems: (items: PersistedOverlayItem[]) => void;
  clearItems: () => void;
};

export const NotesAndPicturesContext = createContext<
  NotesAndPicturesContextValue | undefined
>(undefined);
